/**
 * Per-field confidence badge for AI Lead Intake HITL.
 */

import React from "react";
import { Chip } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

/**
 * @param {{ level?: string, label?: string, size?: 'small'|'medium' }} props
 */
const FieldConfidenceBadge = ({
  level = "not_found",
  label = "Not found",
  size = "small",
}) => {
  let color = "default";
  let icon = null;
  if (level === "high") {
    color = "success";
    icon = <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />;
  } else if (level === "needs_confirmation") {
    color = "warning";
    icon = <WarningAmberIcon sx={{ fontSize: 14 }} />;
  } else if (level === "not_found") {
    icon = <HelpOutlineIcon sx={{ fontSize: 14 }} />;
  } else if (level === "manual") {
    color = "info";
  }

  return (
    <Chip
      size={size}
      color={color}
      variant={level === "optional" || level === "not_found" ? "outlined" : "filled"}
      icon={icon || undefined}
      label={label}
      data-testid={`field-confidence-${level}`}
      sx={{
        height: 22,
        fontSize: "0.7rem",
        "& .MuiChip-icon": { ml: 0.5 },
      }}
    />
  );
};

export default FieldConfidenceBadge;
